:host {
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 100%;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: $xp-ref-color-state-hover;
  border-radius: $xp-ref-border-radius-2;

  opacity: 0;
}

.box {
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 116px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: $xp-ref-spacing-1;
  padding: $xp-ref-spacing-3;
  border-radius: $xp-ref-border-radius-2;
  cursor: pointer;
}

.box.small {
  height: 100%;
  .row {
    .price {
      display: none;
    }
  }
  .description {
    display: none;
  }
}

.box.default {
  background-color: $xp-ref-color-background-component-high-emphasis;
  border: 1px solid $xp-ref-color-border-medium;
  &:hover {
    background-color: rgba($color: $xp-ref-color-background-component-high-emphasis, $alpha: 1);
    //Fallback because variables dont work
    background-color: rgba(white, 0);
    ~ .background {
      opacity: 1;
    }
  }

  &:focus {
    outline: 3px solid $xp-ref-color-border-focus-default;
    outline-offset: 1px;
  }

  &.checked {
    background-color: $xp-ref-color-state-select;
    &:hover {
      background-color: rgba($color: $xp-ref-color-state-select, $alpha: 1);
      //Fallback because variables dont work
      background-color: rgba(purple, 0.1);
      ~ .background {
        opacity: 1;
      }
    }
  }
  .checkmark {
    background-color: inherit;
    border: 1px solid $xp-ref-color-border-heavy;

    &.checked {
      background-color: $xp-ref-color-state-on-select;
      border-color: $xp-ref-color-state-on-select;
      &:after {
        background-color: $xp-ref-color-semantic-on-interaction;
      }
    }
  }
}

.box.error {
  background-color: $xp-ref-color-semantic-critical-low-emphasis;
  border: 1px solid $xp-ref-color-border-medium;
  &:hover {
    background-color: rgba($color: $xp-ref-color-semantic-critical-low-emphasis, $alpha: 1);
    background-color: rgba(red, 0.2);
    ~ .background {
      opacity: 1;
    }
  }
  &:focus {
    outline: 3px solid $xp-ref-color-border-focus-default;
    outline-offset: 1px;
    .checkmark {
      background-color: rgba(red, 0.1);
    }
    ~ .background {
      opacity: 1;
    }
  }
}

.checkmark {
  background-color: inherit;
  border: 1px solid $xp-ref-color-semantic-on-critical;
  &.checked {
    border-color: $xp-ref-color-semantic-on-critical;
    &:after {
      background-color: $xp-ref-color-semantic-on-critical;
    }
  }
}

.box.disabled {
  background-color: $xp-ref-color-state-disabled;
  border: 1px solid $xp-ref-color-state-on-disabled;
  &:hover {
    background-color: $xp-ref-color-state-disabled;
  }
  &:focus {
    outline: none;
  }
  .checkmark {
    background-color: inherit;
    border: 1px solid $xp-ref-color-state-on-disabled;
    &.checked {
      border-color: $xp-ref-color-state-on-disabled;
      &:after {
        background-color: $xp-ref-color-state-on-disabled;
      }
    }
  }
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: $xp-ref-size-5;
  width: $xp-ref-size-5;
  border-radius: 50%;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }
}

.row {
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  gap: $xp-ref-spacing-2;
  background: transparent;
  .price {
    font: $xp-ref-font-paragraph-paragraph-short;
    color: $xp-ref-color-text-default-medium;
    margin-left: auto;
  }
}

.selector {
  background: transparent;
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  font-size: 22px;
}

.title {
  font: $xp-ref-font-label-label-short;
  color: $xp-ref-color-text-default-dark;
  background: transparent;
}

.description {
  position: relative;
  padding-left: $xp-ref-spacing-7;
  font: $xp-ref-font-paragraph-paragraph-small;
  color: $xp-ref-color-text-forms-label;
}

.material-icons-outlined {
  position: absolute;
  left: -1px;
  color: black;
  font-size: 24px;
}
